import React, { FunctionComponent } from 'react';
import Card from '../../Common/Card/Card';

export type Props = {
	mode?: string;
	children: JSX.Element;
};

const Password: FunctionComponent<Props> = ({ children, mode }) => (
	<Card mode={mode} label="Password">
		{children}
	</Card>
);

export default Password;
